import { Injectable } from '@angular/core';
import { ICashRegisterVendorInterface } from '../cash-register-vendor.interface';
import { HttpClient } from '@angular/common/http';
import { LocalAppService } from '../../../app/local-app.service';
import { CashRegisterEntity } from '../../../../models/entity/cash-register/cash-register-entity';
import { CashRegisterPairLocalResponse } from '../../../../models/rest/cash-register/pair/cash-register-pair-local-response';
import { CashRegisterControlTapeLocalResponse } from '../../../../models/rest/cash-register/control-tape/cash-register-control-tape-local-response';
import { CashRegisterCloseShiftLocalResponse } from '../../../../models/rest/cash-register/close_shift/cash-register-close-shift-local-response';
import { CashRegisterXReportLocalResponse } from '../../../../models/rest/cash-register/report/x-report/cash-register-x-report-local-response';
import { CashRegisterZReportBulkLocalResponse } from '../../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-local-response';
import { StringUtils } from '../../../../utils/string.utils';
import { firstValueFrom } from 'rxjs';
import { CashRegisterLoginLocalResponse } from '../../../../models/rest/cash-register/login/cash-register-login-local-response';
import { CashRegisterCreateBasketResponse } from '../../../../models/rest/cash-register/sale/cash-register-create-basket-response';
import { CashRegisterPaymentCancelLocalResponse } from '../../../../models/rest/cash-register/cancel/cash-register-payment-cancel-local-response';
import { CashRegisterOpenShiftLocalResponse } from '../../../../models/rest/cash-register/open_shift/cash-register-open-shift-local-response';
import { request } from 'http';

@Injectable({
  providedIn: 'root'
})
export class CasposService implements ICashRegisterVendorInterface {

  private baseUrl: string = '';
  appName = "CASPOS";
  timeout: 30;

  constructor(private httpClient: HttpClient,
    private localAppService: LocalAppService
  ) { }
  pair(cashRegister: CashRegisterEntity, data: CashRegisterPairLocalResponse) {
    throw new Error('Method not implemented.');
  }


  setBaseUrl(data: CashRegisterEntity) {
    if (StringUtils.isEmpty(data.apiUrl)) {
      throw new Error("Yazar kasa ip adresi boş olamaz");
    }
    this.baseUrl = data.apiUrl!;

    if (!this.baseUrl.includes(":5544"))
      this.baseUrl = this.baseUrl + ":5544";


    if (!this.baseUrl.startsWith("http://")) {
      this.baseUrl = "http://" + this.baseUrl;
    }

  }
  isLoggedIn(data: CashRegisterEntity) {
    return true
  }

  getToken(cashRegister: CashRegisterEntity) {
    return;
  }
  setToken(cashRegister: CashRegisterEntity, token?: string) {
    return;
  }
  getDeviceInfo(cashRegister: CashRegisterEntity) {
    return;
  }
  login(cashRegister: CashRegisterEntity, data: CashRegisterLoginLocalResponse) {
    return;
  }
  async createSale(cashRegister: CashRegisterEntity, request: CashRegisterCreateBasketResponse) {
    this.setBaseUrl(cashRegister);


    const response = await await firstValueFrom(
      this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout)
    );

    return JSON.parse(response.data);

  }
  async cancelSale(cashRegister: CashRegisterEntity, request: CashRegisterPaymentCancelLocalResponse) {
    this.setBaseUrl(cashRegister);
    const response = await firstValueFrom(this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout));
    return JSON.parse(response.data);
  }
  async openShift(cashRegister: CashRegisterEntity, request: CashRegisterOpenShiftLocalResponse) {
    this.setBaseUrl(cashRegister);
    const response = await firstValueFrom(this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout));
    return JSON.parse(response.data);
  }
  async closeShift(cashRegister: CashRegisterEntity, request: CashRegisterCloseShiftLocalResponse) {
    this.setBaseUrl(cashRegister);
    const response = await firstValueFrom(this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout));
    return JSON.parse(response.data);
  }
  async getXReport(cashRegister: CashRegisterEntity, request: CashRegisterXReportLocalResponse) {
    this.setBaseUrl(cashRegister);
    const response = await firstValueFrom(this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout));
    return JSON.parse(response.data);
  }
  async getZReport(cashRegister: CashRegisterEntity, request: CashRegisterZReportBulkLocalResponse) {
    this.setBaseUrl(cashRegister);
    const response = await firstValueFrom(this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout));
    return JSON.parse(response.data);
  }
  controlTape(cashRegister: CashRegisterEntity, request: CashRegisterControlTapeLocalResponse) {
    throw new Error('Method not implemented.');
  }
}
